import React, { useMemo } from 'react';
import {
  TRIAL_RESTRICTION_TYPE,
  TRIAL_USER_LEVEL,
} from '../../consts/restrictionTypes';
import { useGlobalContext } from '../GlobalContextProvider/GlobalContextProvider';
import StaticImage from '../StaticImage';
import UniversalLink from '../UniversalLink/UniversalLink';
import { CommonListLink, Container } from './CommonList.styled';

const compareByTitle = (a, b) => a.title.localeCompare(b.title);

const gatePageIcon = '/img/gated-page-icon.svg';

const CommonList = ({ items }) => {
  const { user } = useGlobalContext();
  const sortedItems = useMemo(() => items.sort(compareByTitle), [items]);

  return (
    <Container>
      {sortedItems.map((el) => {
        const trialUserAvailability =
          user &&
          user.userLevel === TRIAL_USER_LEVEL &&
          el.restrictionType === TRIAL_RESTRICTION_TYPE;

        return (
          <UniversalLink
            useExportPseudoAnchorChild={true}
            href={el.path || el.url || ''}
            key={el.title}
          >
            <CommonListLink>
              {el.title}{' '}
              {trialUserAvailability && (
                <StaticImage
                  width={16}
                  height={16}
                  alt='gatePageIcon'
                  src={gatePageIcon}
                  priority
                />
              )}
            </CommonListLink>
          </UniversalLink>
        );
      })}
    </Container>
  );
};

CommonList.propTypes = {};

CommonList.defaultProps = {};

export default CommonList;
